import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { siteConfig } from '../mock';
import useSEO from '../hooks/useSEO';

/**
 * The /broneerimine route now immediately opens the external SalonLife
 * booking page in a new tab and returns the visitor to the home page.
 */
const Booking = () => {
  useSEO({
    title: 'Broneerimine | Prestige Beauty & Wellness',
    description: 'Broneeri aeg Prestige Beauty & Wellnessi juures Pärnus.',
    path: '/broneerimine',
  });
  const navigate = useNavigate();

  useEffect(() => {
    window.open(siteConfig.bookingUrl, '_blank', 'noopener,noreferrer');
    const t = setTimeout(() => navigate('/', { replace: true }), 400);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div className="hero-bg min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-lg">
        <div className="section-eyebrow">Broneerimine</div>
        <h1 className="font-serif-display text-3xl md:text-4xl text-brand mt-4">
          Suuname teid broneerimislehele…
        </h1>
        <div className="mt-6 flex justify-center"><span className="gold-divider" /></div>
        <p className="text-brand-muted mt-8">
          Kui uus aken ei avanenud automaatselt,{' '}
          <a
            href={siteConfig.bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gold underline hover:no-underline"
          >
            klikkige siia
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default Booking;
